import { Component, Input } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-input',
    templateUrl: './hr-form-input.component.html',
})
export class HrFormInputComponent extends HrBaseElementComponent {
    @Input() type: string = 'text';
    @Input() disabled?: boolean;
}
